import React from 'react';
import PropTypes from 'prop-types';

/**
 * SVGIcon provides a standardized template for displaying svgs
 *
 * Uniform Dependencies
 * @requires css:components/icons
 */
export default class SVGIcon extends React.Component {
  render() {
    const {
      name,
      classes,
      color,
      margin,
      padding,
      fontSize,
      transform,
      rotate,
      path,
      viewBox,
      style,
      ...restProps
    } = this.props;

    const classNames = [
      'icon',
      rotate && 'rotate',
      classes && classes.join(' ')
    ].filter(c => c).join(' ');

    const xLink = path || `/apps/webapps/next/global/blazer/icons/icons.svg#${name}`;

    return (
      <svg
        {...restProps}
        style={{
          ...style,
          margin,
          padding,
          fill: color,
          fontSize,
          transform,
          overflow: 'visible' // prevents svg clipping in edge cases,
        }}
        className={classNames}
        viewBox={viewBox || '0 0 2048 2048'}
      >
        <use xlinkHref={xLink} />
      </svg>
    )
  }
}

SVGIcon.propTypes = {
  name: PropTypes.string,
  path: PropTypes.string,
  viewBox: PropTypes.string,
  color: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  fontSize: PropTypes.string,
  transform: PropTypes.string,
  rotate: PropTypes.bool,
  style: PropTypes.object,
  /**
   * @deprecated
   */
  classes: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/main/webapps/common/react/components/svg-icon.js